import {
  LEAD_NOTE_CHANNELS,
  type TLeadNote,
} from '@src/shared/types/lead-note';
import { Buildings2, Call, Sms, Whatsapp } from 'iconsax-react';
import { HashIcon } from 'lucide-react';

export const NOTE_CHANNELS_OPTIONS = [
  { value: LEAD_NOTE_CHANNELS.office, icon: Buildings2, label: 'Office' },
  { value: LEAD_NOTE_CHANNELS.call, icon: Call, label: 'Call' },
  { value: LEAD_NOTE_CHANNELS.whatsapp, icon: Whatsapp, label: 'Whatsapp' },
  { value: LEAD_NOTE_CHANNELS.email, icon: Sms, label: 'Email' },
  { value: LEAD_NOTE_CHANNELS.other, icon: HashIcon, label: 'Other' },
];

export const getChannelIcon = (channel: TLeadNote['channel']) => {
  return NOTE_CHANNELS_OPTIONS.find((option) => option.value === channel)?.icon;
};
